import { Layers, Compass, Cloud, Workflow } from "lucide-react";

const competencies = [
  {
    icon: Layers,
    title: "Technical Leadership",
    desc: "Guiding development teams, establishing best practices, and acting as the technical translator between stakeholders and developers.",
  },
  {
    icon: Cloud,
    title: "Cloud Architecture",
    desc: "Designing and implementing enterprise-grade applications using .NET Core, C#, and Angular, with a strong focus on microservices and cloud hosting trade-offs.",
  },
  {
    icon: Workflow,
    title: "AI & Automation",
    desc: "Leveraging intelligent automation, web scraping, and prompt engineering to accelerate workflows and act as a force multiplier for the entire engineering process.",
  },
  {
    icon: Compass,
    title: "Product Ownership",
    desc: "Deeply understanding business requirements to ensure the technical roadmap aligns perfectly with the final product goals.",
  },
];

export function About() {
  return (
    <section id="about" className="py-24 md:py-32">
      <div className="mx-auto grid max-w-7xl gap-12 px-6 md:grid-cols-2 md:gap-20">
        <div className="flex flex-col gap-6">
          <p className="font-mono text-sm text-primary">// About Me</p>
          <h2 className="text-3xl font-bold tracking-tight text-foreground md:text-4xl">
            Tech Lead & Full-Stack Architect.
          </h2>
          <div className="space-y-4 text-muted-foreground leading-relaxed">
            <p>
              I&apos;m an Technical Lead,  
              With 12+ years of experience and many successful projects delivered, 
              I don't just build software, I engineer systems that solve complex business problems. 
              I build scalable software, lead engineering teams, and bridge the gap between complex technical architecture and strategic business goals.
              I bridge the gap between product vision and technical execution by wearing multiple hats:
            </p>
            <p>
              My core philosophy: AI is a{" "}
              <span className="font-medium text-foreground">force multiplier</span> in software
              engineering. I lead teams through microservices decompositions, cloud pattern
              trade-offs, and the practical adoption of AI across the SDLC. without ever losing
              sight of the craft.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          {competencies.map((c) => (
            <div
              key={c.title}
              className="group rounded-xl border border-border bg-surface p-6 transition-smooth hover:-translate-y-1 hover:border-primary/50 hover:shadow-elevated"
            >
              <div className="mb-4 inline-flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10 text-primary transition-smooth group-hover:bg-primary/20">
                <c.icon className="h-5 w-5" />
              </div>
              <h3 className="mb-1 font-semibold text-foreground">{c.title}</h3>
              <p className="text-sm text-muted-foreground">{c.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
